var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 69,
      height: 68,
      viewBox: "0 0 69 68",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 63.7487C9 62.9663 9.63426 62.332 10.4167 62.332L64.25 62.332C65.0324 62.332 65.6667 62.9663 65.6667 63.7487C65.6667 64.5311 65.0324 65.1654 64.25 65.1654L10.4167 65.1654C9.63426 65.1654 9 64.5311 9 63.7487Z"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.91666 63.7487C1.91666 62.9663 2.55092 62.332 3.33332 62.332L6.16666 62.332C6.94906 62.332 7.58332 62.9663 7.58332 63.7487C7.58332 64.5311 6.94906 65.1654 6.16666 65.1654L3.33402 65.1654C2.55161 65.1654 1.91666 64.5311 1.91666 63.7487Z"
    })), _ref4 || (_ref4 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M55.3272 43.8122L55.686 44.6977L54.9996 45.3622C54.4125 45.9305 54.0503 46.7226 54.0503 47.6019C54.0503 47.838 54.0763 48.0663 54.125 48.2848L54.2731 48.9486L53.8478 49.4792C53.2646 50.207 52.9167 51.1281 52.9167 52.1344C52.9167 54.2402 54.4483 55.9884 56.4583 56.3256V53.8346C56.4583 53.4434 56.7755 53.1263 57.1667 53.1263C57.5579 53.1263 57.875 53.4434 57.875 53.8346V56.3256C59.8851 55.9884 61.4167 54.2402 61.4167 52.1344C61.4167 51.1283 61.0689 50.2074 60.4858 49.4797L60.0606 48.9489L60.2088 48.2852C60.2576 48.0666 60.2836 47.8381 60.2836 47.6019C60.2836 46.7224 59.9213 45.9301 59.3339 45.3618L58.6473 44.6974L59.006 43.8119C59.0983 43.584 59.1499 43.3338 59.1499 43.068C59.1499 41.9726 58.2619 41.0846 57.1665 41.0846C56.0712 41.0846 55.1832 41.9726 55.1832 43.068C55.1832 43.3339 55.2348 43.5843 55.3272 43.8122ZM57.875 57.7572C60.6703 57.4086 62.8333 55.0241 62.8333 52.1344C62.8333 50.7948 62.3685 49.5638 61.5914 48.5939C61.6627 48.2746 61.7003 47.9426 61.7003 47.6019C61.7003 46.3231 61.1708 45.1679 60.3191 44.3437C60.4787 43.9498 60.5665 43.5191 60.5665 43.068C60.5665 41.1902 59.0443 39.668 57.1665 39.668C55.2888 39.668 53.7665 41.1902 53.7665 43.068C53.7665 43.5194 53.8545 43.9502 54.0142 44.3443C53.1629 45.1685 52.6336 46.3234 52.6336 47.6019C52.6336 47.9424 52.6712 48.2742 52.7424 48.5933C51.965 49.5634 51.5 50.7946 51.5 52.1344C51.5 55.0241 53.663 57.4086 56.4583 57.7572V60.918V63.7513C56.4583 64.1425 56.7755 64.4596 57.1667 64.4596C57.5579 64.4596 57.875 64.1425 57.875 63.7513V61.2114L59.0842 60.0022C59.3608 59.7255 59.3608 59.2771 59.0842 59.0004C58.8076 58.7238 58.3591 58.7238 58.0825 59.0004L57.875 59.2079V57.7572ZM57.1667 48.8763C56.7755 48.8763 56.4583 49.1934 56.4583 49.5846V51.0013C56.4583 51.3925 56.7755 51.7096 57.1667 51.7096C57.5579 51.7096 57.875 51.3925 57.875 51.0013V49.5846C57.875 49.1934 57.5579 48.8763 57.1667 48.8763Z"
    })), _ref5 || (_ref5 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M37.3333 39.6667H29.5417V47.4583H37.3333V39.6667ZM37.3333 48.875H29.5417V56.6667H37.3333V48.875ZM28.125 47.4583V39.6667H20.3333V47.4583H28.125ZM20.3333 48.875H28.125V56.6667H20.3333V48.875ZM20.3333 38.25C19.5509 38.25 18.9167 38.8843 18.9167 39.6667V56.6667C18.9167 57.4491 19.5509 58.0833 20.3333 58.0833H37.3333C38.1157 58.0833 38.75 57.4491 38.75 56.6667V39.6667C38.75 38.8843 38.1157 38.25 37.3333 38.25H20.3333Z"
    })), _ref6 || (_ref6 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.8333 34.707C12.2245 34.707 12.5417 35.0242 12.5417 35.4154V63.7487C12.5417 64.1399 12.2245 64.457 11.8333 64.457C11.4421 64.457 11.125 64.1399 11.125 63.7487V35.4154C11.125 35.0242 11.4421 34.707 11.8333 34.707Z"
    })), _ref7 || (_ref7 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M45.8333 34.707C46.2245 34.707 46.5417 35.0242 46.5417 35.4154V63.7487C46.5417 64.1399 46.2245 64.457 45.8333 64.457C45.4421 64.457 45.125 64.1399 45.125 63.7487V35.4154C45.125 35.0242 45.4421 34.707 45.8333 34.707Z"
    })), _ref8 || (_ref8 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.115 19.4339C28.5584 19.1731 29.1083 19.1731 29.5516 19.4339L52.6599 33.027C53.3385 33.4261 53.5614 34.3019 53.1564 34.9769L51.7496 37.3217C51.3581 37.9742 50.5209 38.2009 49.8536 37.8349L28.8333 26.3077L7.813 37.8349C7.14573 38.2009 6.30858 37.9742 5.91704 37.3217L4.51022 34.9769C4.1052 34.3019 4.32819 33.4261 5.00672 33.027L28.115 19.4339ZM28.8333 20.6549L5.725 34.2481L7.13182 36.5928L28.1521 25.0655C28.5765 24.8328 29.0902 24.8328 29.5145 25.0655L50.5348 36.5928L51.9416 34.2481L28.8333 20.6549Z"
    })), _ref9 || (_ref9 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M38.0417 17.7096C38.0417 16.9272 38.6759 16.293 39.4583 16.293H43.7083C44.4907 16.293 45.125 16.9272 45.125 17.7096V27.6263H43.7083V17.7096L39.4583 17.7096V24.793H38.0417V17.7096Z"
    })), _ref10 || (_ref10 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.6667 10.6237C16.2176 10.6237 17.5374 11.621 18.0163 13.0113L18.1585 13.4243L18.5914 13.4826C19.9748 13.6691 21.0417 14.8557 21.0417 16.2904C21.0417 17.8552 19.7731 19.1237 18.2083 19.1237H9.70834C8.14354 19.1237 6.87501 17.8552 6.87501 16.2904C6.87501 14.7256 8.14354 13.457 9.70834 13.457H11.1594L11.3264 12.9847C11.8129 11.6082 13.1257 10.6237 14.6667 10.6237ZM19.2013 12.1571C18.4308 10.42 16.6912 9.20703 14.6667 9.20703C12.6878 9.20703 10.9812 10.3659 10.1857 12.0404H9.70834C7.36113 12.0404 5.45834 13.9432 5.45834 16.2904C5.45834 18.6376 7.36113 20.5404 9.70834 20.5404H18.2083C20.5556 20.5404 22.4583 18.6376 22.4583 16.2904C22.4583 14.2848 21.0697 12.6046 19.2013 12.1571Z"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgHouse, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/house.6ccfc13a.svg";
export { ForwardRef as ReactComponent };